/**
 * Created by Roman on 2015-03-26.
 */


angular.module('fliptoWeb')
    .directive('ftLoadingAnimation', ['$compile', '$animate', function ($compile, $animate) {

        var template = '<span class="loading-animation">{{message}} <ft-spinner></ft-spinner></span>';

        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {

                var options = angular.extend({disableUi: true}, scope.$eval(attrs.ftLoadingAnimation)),
                    loadingAnimation = $compile(template)(angular.extend(scope.$new(true), options)),
                    lastChild = elem[0].childNodes && elem[0].childNodes[elem[0].childNodes.length - 1];

                scope.$watch(function () {
                    return  scope.$eval(attrs.ftLoadingAnimation).trigger;
                }, function (show) {

                    if (show) {
                        $animate.enter(loadingAnimation, elem, lastChild);
                    } else {
                        $animate.leave(loadingAnimation);
                    }
                    elem.css('pointer-events', options.disableUi && show ? 'none' : '');
                    options.disableUi && show && elem.attr('disabled', 'disabled');
                    options.disableUi && !show && elem.removeAttr('disabled');
                });

            }
        };
    }]);